import { breakpoints } from '../../../foundations';
import { MultiDynamicMediaImageConfigs } from '../../dynamic-media-picture';

export const imageConfigSingleCard: MultiDynamicMediaImageConfigs = [
  {
    aspectRatio: '16-9',
    sizes: '100vw',
    media: `(max-width: ${breakpoints.m / 16}em)`
  },
  {
    aspectRatio: '16-9',
    sizes: '70vw',
    media: `(max-width: ${breakpoints.l / 16}em)`
  },
  {
    aspectRatio: '3-4',
    sizes: '33vw',
    media: `(min-width: ${breakpoints.l / 16}em)`
  }
];

export const imageConfigMultiMobile: MultiDynamicMediaImageConfigs = [
  {
    aspectRatio: '3-4',
    sizes: '40vw',
    media: `(max-width: ${breakpoints.m / 16}em)`
  },
  {
    aspectRatio: '3-4',
    sizes: '25vw',
    media: `(max-width: ${breakpoints.l / 16}em)`
  }
];
